<template>
  <v-app>
    <v-main class="mt-1">
      <v-card flat style="min-height: 550px" max-width="850" class="mx-auto card-outter rounded-0">
        <booking-process :bookingIframe="true" :bgColor="bgColor" :dark="true" />
      </v-card>
    </v-main>
  </v-app>
</template>

<script lang="ts">
import BookingProcess from "@/components/booking/customer/BookingProcess.vue";
import LayoutSimple from "@/layouts/LayoutSimple.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    LayoutSimple,
    BookingProcess
  }
})
export default class BookingIFrame extends Vue {
  get bgColor() {
    return "#1E1E1E";
  }
}
</script>
